let supportedStyles = null;
function isCssPropertySupports(property) {
  if (!supportedStyles) {
    const div = document.createElement('div');
    supportedStyles = div.style;
  }
  return property in supportedStyles;
}
export function isWebkitLineClampSupports() {
  return isCssPropertySupports('webkitLineClamp') || isCssPropertySupports('-webkit-line-clamp');
}
